import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Pool} from '../../models/landing-page/pool';

@Injectable({
  providedIn: 'root'
})
export class PoolService extends AbstractModelService<Pool> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/pool', Pool);
  }
}
